export const mongoose = {Schema: {Types: {ObjectId: 'ID'}}};
export const [SECTOR, PROJECT, SITE, BINS_PLACEMENT] = ['Sector', 'Project', 'Site', "BinsPlacement",];